var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsAvatarOutlineBrand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 104 99",
    style: {
      enableBackground: "new 0 0 104 99"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2D2D2D;}\n\t.st1{fill:#7D7D7D;}\n\t.st2{fill:#464646;}\n\t.st3{fill:#D04A02;}\n\t.st4{fill:#E0301E;}\n\t.st5{fill:#DB536A;}\n\t.st6{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52,13.5c-19.9,0-36,16.1-36,36c0,9.8,3.9,18.7,10.2,25.1l1.5,1.6c0,0,0.1-0.1,0.1-0.1c6.4,5.8,14.9,9.3,24.2,9.3 c9.3,0,17.8-3.5,24.2-9.3c0,0,0.1,0.1,0.1,0.1l1.3-1.4C84,68.3,88,59.4,88,49.5C88,29.6,71.9,13.5,52,13.5z M52,81 c-7.8,0-14.9-2.8-20.4-7.5c5.4-3.2,12.7-5.1,20.4-5.1c7.7,0,15,1.8,20.4,5.1C66.9,78.2,59.8,81,52,81z M75.7,70.2 c-6.2-4-14.7-6.3-23.7-6.3c-9,0-17.5,2.3-23.7,6.3c-4.8-5.5-7.8-12.8-7.8-20.7C20.5,32.1,34.6,18,52,18s31.5,14.1,31.5,31.5 C83.5,57.4,80.6,64.7,75.7,70.2z M52,33.3c-6.6,0-11.9,5.3-11.9,11.9C40.1,51.7,45.4,57,52,57c6.6,0,11.9-5.3,11.9-11.9 C63.9,38.6,58.6,33.3,52,33.3z M52,52.5c-4.1,0-7.4-3.3-7.4-7.4c0-4.1,3.3-7.4,7.4-7.4c4.1,0,7.4,3.3,7.4,7.4 C59.4,49.2,56.1,52.5,52,52.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsAvatarOutlineBrand);
export default __webpack_public_path__ + "static/media/Icons_Avatar_Outline_Brand.d81747c8b14a2ec0f5125561b0d13407.svg";
export { ForwardRef as ReactComponent };